import axios from 'axios'

import config from '../../config.client.js'

const url = config.apiUrl

export default {
  getAccounts: organisationId => axios.get(url + `organisations/${organisationId}/accounts`),

  addAccount: (email, givenName, familyName, organisationId, initialLanguage, roles) =>
    axios.post(url + `organisations/${organisationId}/accounts`, {
      email: email.toLowerCase(),
      givenName: givenName,
      familyName: familyName,
      language: initialLanguage,
      roles: roles
    }),

  deleteAccount: accountId => {
    return axios.delete(url + `accounts/${accountId}`)
  },

  getUsageLogSummary: (organisationId, year, month) =>
    axios.get(url + `organisations/${organisationId}/log/usage/${year}/${month}`),

  promoteToAdmin: (organisationId, accountId) =>
    axios.patch(url + `organisations/${organisationId}/accounts/${accountId}/promote`, {})
}



// WEBPACK FOOTER //
// ./src/services/organisation-admin.js